import { getPlatformType, isDianpingAppOrWebview, PlatformType } from '@nibfe/mkt-env-api';
export const getCityListApi = (cityInfo, isMt = true) => {
    const ids = isMt ? cityInfo === null || cityInfo === void 0 ? void 0 : cityInfo.mtCityList : cityInfo === null || cityInfo === void 0 ? void 0 : cityInfo.dpCityList;
    const names = cityInfo === null || cityInfo === void 0 ? void 0 : cityInfo.nameList;
    const pinyins = cityInfo === null || cityInfo === void 0 ? void 0 : cityInfo.pinyinList;
    if (!ids || ids.length !== (names === null || names === void 0 ? void 0 : names.length))
        return [];
    return names === null || names === void 0 ? void 0 : names.map((name, index) => {
        return {
            name: name,
            id: ids[index],
            pinyin: pinyins[index]
        };
    });
};
const getAlphabetCities = (cities) => {
    const alphabetCitiesMap = cities.reduce((map, city) => {
        var _a;
        const firstAlphabet = (_a = city === null || city === void 0 ? void 0 : city.pinyin) === null || _a === void 0 ? void 0 : _a.trim()[0].toUpperCase();
        map[firstAlphabet] = map[firstAlphabet] || [];
        map[firstAlphabet].push(city);
        return map;
    }, {});
    const cityClasses = [];
    return cityClasses.concat(Object.keys(alphabetCitiesMap).map(key => {
        return {
            label: key,
            showAll: false,
            data: alphabetCitiesMap[key]
        };
    }).sort((a, b) => a.label.charCodeAt(0) - b.label.charCodeAt(0)));
};
export const getCityList = (cityInfo) => {
    // 兜底用美团环境
    const isMt = !(isDianpingAppOrWebview() || getPlatformType() === PlatformType.dpMinaWebview);
    const cityList = getCityListApi(cityInfo, isMt);
    return getAlphabetCities(cityList);
};
/*export const getHotCityList = (isMt = true) => {
  return getHotCityListApi(isMt);
};*/
export function getLetters(cityInfo) {
    const list = getCityList(cityInfo);
    return list.map(item => item === null || item === void 0 ? void 0 : item.label);
}
